import Api from '@/api'

export default {

  async blackjack(cb) {
    const result = await Api.get('v1/statistics/games/blackjack')
    cb(result)
  },

  async roulette(cb) {
    const result = await Api.get('v1/statistics/games/roulette')
    cb(result)
  },

  async core(cb) {
    const result = await Api.get('v1/statistics')
    cb(result)
  },

  async ec(cb) {
    const result = await Api.get('v1/statistics/ec')
    cb(result)
  },

  async minecraft( options, cb ) {
    const result = await Api.get( 'v1/statistics/minecraft?' + new URLSearchParams(options).toString() )
    cb( result )
  }

}
